import { WidgetChartNumeric } from '../Widgets';
import { connect } from 'react-redux';
import { getBillingData } from '../../redux/actions/billing';
import { sumByField, formatDate, formatDateFromRange } from '../../helpers';

const mapStateToProps = (state, ownProps) => ({
  id: 'WidgetBilling',
  className: ownProps.className,
  width: ownProps.width,
  height: ownProps.height,
  graph: state.billing.WidgetBilling && state.billing.WidgetBilling.data && state.filter.filters.startDate && state.filter.filters.endDate ? state.billing.WidgetBilling.data.map(item => ({
    cat: formatDateFromRange(item.dt, state.filter.filters),
    Billed: {
      value: item.bSuccess,
      label: 'bSuccess'
    },
    Attempts: {
      value: item.bAttempts > item.bSuccess ? item.bAttempts - item.bSuccess : 0,
      label: 'bAttempts'
    }
  })) : [],
  exportData: state.billing.WidgetBilling && state.billing.WidgetBilling.data && state.filter.filters.startDate && state.filter.filters.endDate ? state.billing.WidgetBilling.data.map(item => ({ date: item.dt, Billed: item.bSuccess, Attempts: item.bAttempts })) : [],
  info: state.billing.WidgetBilling ? [{
    amount: sumByField(state.billing.WidgetBilling.data, 'bAttempts'),
    description: "Billing Count"
  }, {
    amount: sumByField(state.billing.WidgetBilling.data, 'bSuccess'),
    description: "Success"
  }, {
    amount: state.billing.WidgetBilling.data ? Math.min((sumByField(state.billing.WidgetBilling.data, 'bSuccess') / sumByField(state.billing.WidgetBilling.data, 'bAttempts')) * 100, 999) : 0,
    type: "percentage",
    description: "Billing Ratio"
  }] : [],
  filters: {
    oc: state.filter.filters.oc,
    srvcId: state.filter.filters.service,
    startDate: state.filter.filters.startDate,
    endDate: state.filter.filters.endDate,
    tz: state.filter.filters.tz
  },
  colorScheme: ownProps.colorScheme,
  title: ownProps.title,
  onZoom: ownProps.onZoom,
  dataLoaded: state.billing.WidgetBilling
    && state.billing.WidgetBilling.loaded,
  filtersLoaded: state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.startDate
    && state.filter.filters.endDate,
  loaded: state.billing.WidgetBilling
    && state.billing.WidgetBilling.loaded
    && state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.startDate
    && state.filter.filters.endDate,
  shouldLoadData: !state.billing.WidgetBilling || (!state.billing.WidgetBilling.loaded && !state.billing.WidgetBilling.loading && !state.billing.WidgetBilling.error)
})

const mapDispatchToProps = { fetchData: getBillingData };

export default connect(mapStateToProps, mapDispatchToProps)(WidgetChartNumeric)



// WEBPACK FOOTER //
// ./src/components/ConnectedWidgets/WidgetBillingConnected.js